import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { readPayers } from 'api/Payer';

export const usePayersSearch = ({ params = {}, options = {}, dependencies = [] }) => {
  const navigate = useNavigate();

  return useQuery(['payers-search', ...dependencies], () => readPayers(navigate, params), {
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...options
  });
};
